(function (app) {
    app.provider("carrierMappingApi", [function () {
        this.$get = ["dataFeedApiGateway", function (dataFeedApiGateway) {
            var service = {};

            // GETS
            service.getMappedCarriers = function() {
                return dataFeedApiGateway.get("/Carriers/Mapped");
            };

            service.getFileNames = function (fileGroupId) {
                return dataFeedApiGateway.get("/SftpAPI/FileGroups/" + fileGroupId);
            };

            service.getUnmappedCarriers = function() {
                return dataFeedApiGateway.get("/Carriers/Unmapped");
            };

            // POSTS
            service.createCarrierMap = function(carrier) {
                return dataFeedApiGateway.post("/Carriers/Mapped", carrier);
            };

            // PUTS
            service.mapCarrier = function(carrier, link) {
                return dataFeedApiGateway.put("/Carriers/Unmapped/" + carrier.UnmappedCarrierId, link);
            };

            service.updateMappedName = function (carrier) {
                return dataFeedApiGateway.put("/Carriers/UpdateMappedCarrierName/" + carrier.MappedCarrierId, carrier);
            };

            return service;
        }];
    }]);
})(window.app);
